let initOrgin = 'hokkj'
if (window.origin.includes('hcbnjyai')) {
  initOrgin = 'hcbnjyai'
} else if (window.origin.includes('aifxy')) {
  initOrgin = 'aifxy'
}

import * as modules from './config'
// window.config = modules.default[initOrgin]
export default modules.default[initOrgin]
